import { SiteList } from '~/modules/sites';
import { usePageTitle } from '~components/DashboardWrapper/PageTitle';
import { t } from '~/i18n';

export default function SiteListPage() {
  usePageTitle(t('menu.dashboard.settingsSites'));
  return <SiteList />;
}
